import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useRef } from 'react';
import { useDayRender } from 'react-day-picker';
import { DateShort, NumberFormat } from '@medable/i18n-core';
import { LocaleContext } from '../../../../i18n/src';
import { toPlainDate, toZonedDateTime } from '../date_utils';
const getModifierKey = (activeModifiers) => {
    const { selected, today, range_start, range_end, range_middle, outside, disabled } = activeModifiers;
    if (range_middle) {
        return 'middle';
    }
    if (selected || range_start || range_end) {
        return 'selected';
    }
    if (disabled) {
        return 'disabled';
    }
    if (today) {
        return 'today';
    }
    if (outside) {
        return 'outside';
    }
    return 'default';
};
// TODO: Modify this once we have a Circular Button component
export const CalendarDayButton = (props) => {
    const ref = useRef(null);
    const { buttonProps, activeModifiers } = useDayRender(props.date, props.displayMonth, ref);
    const locale = useContext(LocaleContext).toString();
    const handleOnClick = (e) => {
        var _a;
        e.preventDefault();
        (_a = buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, e);
    };
    if (activeModifiers.hidden) {
        return null;
    }
    return (_jsx("button", Object.assign({ ref: ref }, buttonProps, { onClick: handleOnClick, "aria-label": new DateShort(locale).format(toZonedDateTime(toPlainDate(props.date))), className: `
            nucleus-box-border nucleus-inline-flex nucleus-h-8 nucleus-w-8 nucleus-max-w-full nucleus-cursor-pointer nucleus-items-center nucleus-justify-center nucleus-border-none nucleus-font-medium nucleus-normal-case nucleus-transition-colors nucleus-m-0
            nucleus-rounded-full
            nucleus-p-0 nucleus-px-4 nucleus-py-2
            hover:nucleus-bg-neutral-600 dark:hover:nucleus-bg-neutral-300
            hover:nucleus-text-white
            focus:nucleus-outline-none focus:nucleus-ring-2 focus:nucleus-ring-primary-500
            focus-visible:nucleus-text-text-primary active:nucleus-bg-primary-500
            disabled:nucleus-pointer-events-none disabled:nucleus-text-text-disabled
            ${{
            default: 'nucleus-bg-transparent nucleus-text-text-primary',
            selected: 'nucleus-bg-primary-500 nucleus-text-white hover:nucleus-bg-neutral-300 hover:nucleus-text-text-primary hover:nucleus-ring-primary-700 focus-visible:nucleus-text-white focus-visible:nucleus-bg-primary-500 focus-visible:nucleus-ring-primary-800',
            today: 'nucleus-bg-transparent nucleus-text-primary-700 dark:nucleus-text-primary-300 nucleus-underline',
            outside: 'nucleus-bg-transparent nucleus-text-neutral-450',
            middle: 'nucleus-bg-primary-200 nucleus-text-text-primary dark:nucleus-bg-primary-800',
            disabled: 'nucleus-bg-transparent disabled:nucleus-line-through',
        }[getModifierKey(activeModifiers)]}
          `, children: new NumberFormat(locale).format(props.date.getDate()) })));
};
//# sourceMappingURL=calendar_day_button.js.map